module.exports = __webpack_public_path__ + "img/title-2.fd05d7c9.png";